import axios from 'axios';
import { convertPath, electronConfig } from '../libs/roomnew';
export default class UserPreferences {
    constructor(){

        //register new features here
        this.features={
            pull_focus:null,
            move_to_spaces_auto:null,
            move_to_spaces_manual:null,
            kino_timer:null,
            camera_options:null
        };

    }

    registerFeatureHandler(feature_name,handler){
        this.features[feature_name]=handler;
    };

    async loadAllPreferences(){
        axios.get(convertPath(`/preferences/all`),await electronConfig()).then(features=>{
            let preferences=features.data;
            // console.log(`loaded all stored preferences ${typeof preferences}`, preferences);
            if(typeof preferences == 'object'){
                preferences.forEach(feature => {
                    if(typeof this.features[feature.feature_name] == 'function'){
                        this.features[feature.feature_name].call(this,feature.properties);
                    }
                });
                //check for features with no preferences
                Object.keys(this.features).forEach(feature_name=>{
                    if(this.features[feature_name]){
                        let hasData=preferences.find(f=>f.feature_name==feature_name);
                        if(!hasData){
                            this.features[feature_name].call(this,{});
                        }
                    }

                });
            }



        }).catch(err=>{
            console.error(err);
            Object.keys(this.features).forEach(feature_name=>{
                if(!typeof this.features[feature_name] == 'function'){return}
                this.features[feature_name].call(this,{});
            });
        })
    };

    async storeNewPreferences(feature_name,preferences){
        axios.post(convertPath(`/preferences/${feature_name}/update`),{
            preferences:JSON.stringify(preferences)
        },await electronConfig()).then(res=>{
            // console.log("Preferences for "+feature_name+" Saved");
        }).catch(err=>{
            console.error(err)
        });
    };
};
